<div class="section-container note-container" [formGroup]="formGroup">
  <h3 class="section-title">{{ translations['leaveNote'] }}?</h3>
  <app-input
    formControlName="nota"
    type="textArea"
    [placeholder]="translations['notePlaceholder'] || 'Write your preferences...'"
    [rows]="3"
  ></app-input>
</div>
